import {normalizeTinyNumber} from "@Common/utils/math/normalize-tiny-number";

export const toCssPos = (p) => ({
    top : normalizeTinyNumber(p.y),
    left: normalizeTinyNumber(p.x),
});
